let ModalView = require("../../templates/ModalView.handlebars");
let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
import i18n from "../../utils/i18n";

let main = function () {

    return Backbone.View.extend({
        initialize: function (options) {
            var self = this, el;
            options = options || {};

            if (!self.model) {
                self.model = new Backbone.Model(options);
            }

            options.id = options.id || self.model.id || ("modalDialog" + (new Date().getTime()));

            if (!self.model.id) {
                self.model.set({id: options.id});
            }
            el = $(ModalView(options));
            if (options.body) {
                el.find(".modal-body").empty().append(options.body);
                delete options.body;
            }
            self.setElement(el);
            self.model.on("change:confirmed", self.close, self);
            return self;
        },

        events: {
            "click .btn-confirm": "_confirm",
            "hidden.bs.modal": "onClose"
        },

        body: function (html) {
            this.$(".modal-body").empty().append(html);
        },

        render: function (options) {
            this.$el.modal(options);
            return this;
        },
        print: function () {
            this.$el.printArea({mode: "popup"});
            return this;
        },

        isDeleteModal: function () {
            this.$(".modal-footer button").removeClass("btn-success").addClass("btn-danger").text(i18n.msg("pos.delete"));
        },
        close: function (options) {
            var self = this;
            self.$(".btn-close").click();
            //Because of the fade effect
            _.delay(function () {
                if (self.hasOwnProperty('modal')) {
                    self.modal("hide");
                }else{
                    self.$el.modal("hide");
                }
                self.remove();
            });
        },
        _confirm: function () {
            this.model.set({shouldConfirm: true, confirmedTime: new Date().getTime()});
        },
        confirmButtonName: function(name) {
            this.$(".modal-footer .btn-confirm").text(name);
        },

        onClose: function(){
            this.model.set({shouldClose: true, closeTime: new Date().getTime()});
            this.trigger("closed");
        }
    });
};

let exportedValue = main();
export default exportedValue



// WEBPACK FOOTER //
// ./src/view/comp/ModalView.js